import React, {useEffect, useState} from 'react';
import Inner from '../components/Inner';
import * as htmlToImage from 'html-to-image';
import image from '../utils/data-uri'
import clean_up_date from '../utils/time-cleanup'
import numberWithCommas from '../utils/number-cleanup';
const download = require('downloadjs')

const Generated = ({user, likes_count, view_count, shot_count}) => {
  const [option, setOption] = useState('')

  const doThingWithImage = event => {
    return htmlToImage.toPng(document.querySelector('.card'),{})
    .then(function (dataUrl) {
      document.querySelector('.preview-img').setAttribute('src', dataUrl)
    });
  }
  useEffect(() => {
    image(user.avatar_url).then(() => {
      doThingWithImage()
    })
  }, [option, user.avatar_url])


  const change_color = (event) => {
    setOption(event.currentTarget.value)
  }

  const download_image = event => {
    htmlToImage.toPng(document.querySelector('.card'), {
      width: document.querySelector('.card').offsetWidth,
      height: document.querySelector('.card').offsetHeight
    })
  .then(function (dataUrl) {
    console.log(dataUrl)
    download(dataUrl, 'my-dribbble-card.png');
  });
  }

  return (
    <div className="hero has-options">
      <Inner>
        <div>
          <h1>Your card has <br/>been generated!</h1>
          <p>Choose your style and then click download.</p>
          <div className="options">
            <div className="checkbox">
              <input onChange={(event) => change_color(event)} type="radio" id="default" name="color" value="" />
                <label for="default" className="checkbox-element-parent">	
                  <span className="checkbox-element">
                  </span>
              </label>
            </div>
            <div className="checkbox light">
              <input onChange={(event) => change_color(event)} type="radio" id="grey" name="color" value="light"/>
                <label for="grey" className="checkbox-element-parent">	
                  <span className="checkbox-element">
                  </span>
              </label>
            </div>
          </div> 
          <button className="cta" onClick={(event) => download_image(event)}>Download</button>
        </div>
        <div>
          <img className="preview-img" src="" alt="preview of card"/>
        </div>
      </Inner>
      <div className="card-parent">
      <div className={`card ${option}`}>
            <div className="card__row">
              <div className="card__inner nav flex">
                <div className="card__user">
                  <div className="card__avatar">
                    <div className="image"></div>
                  </div>

                  <div className="card__info">
                    <h1>{user.name}</h1>
                    <h3>{user.login}<span className="spacer">|</span><span className="followers">{numberWithCommas(user.followers_count)} followers</span></h3>
                  </div>
                </div>
                <div className="card__dribbble">
                  <svg width="100" height="24" viewBox="0 0 75 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M74.2079 12.4649C73.9753 12.2996 73.791 12.276 73.6387 12.5909C71.0259 18.1413 66.6258 15.37 67.0667 15.6141C68.0445 15.1732 70.6092 13.1577 70.2244 10.3628C69.9921 8.65435 68.5013 7.89855 66.9144 8.17409C64.1494 8.64648 63.1395 11.5752 63.6524 14.1655C63.7406 14.6142 63.9009 14.9764 64.0693 15.3386C60.9515 17.8343 59.7093 13.1105 59.5649 12.5436C59.557 12.5121 61.9774 10.536 62.6506 5.82007C63.3559 0.883676 61.753 -0.021722 60.1101 0.00977004C57.0725 0.0648812 56.2549 6.29244 57.3529 11.4808C57.2647 11.5044 56.8319 11.7406 56.1428 11.7642C55.6458 10.229 53.5219 8.88268 52.9689 9.40228C51.5823 10.7013 53.3055 13.2364 54.5238 13.4333C53.7944 17.85 49.2261 16.7557 50.0756 11.221C51.5583 8.51263 52.6964 4.47378 52.4881 2.041C52.4159 1.18285 51.7667 0.0255161 50.3 0.0806272C47.4789 0.19085 47.1743 6.41841 47.5029 10.8431C47.4869 10.7328 47.3266 11.3784 46.1724 11.7012C45.8999 10.2132 43.4555 8.70946 42.8785 9.43378C41.8045 10.7801 43.6719 13.1813 44.5535 13.3467C43.8242 17.7634 39.2559 16.6691 40.1054 11.1344C41.5962 8.42604 42.7262 4.39504 42.5258 1.96229C42.4538 1.10412 41.8045 -0.0532141 40.3377 0.00189702C37.5166 0.112119 37.212 6.33967 37.5408 10.7643C37.5246 10.6541 37.3643 11.3233 36.1621 11.6382C36.1221 9.70146 33.6697 8.81968 33.0765 9.43378C32.0266 10.536 33.3169 12.7956 34.5111 13.3467C33.7818 17.7634 29.2135 16.6691 30.063 11.1344C31.5458 8.42604 32.6839 4.38718 32.4755 1.9544C32.4114 1.10412 31.7622 -0.0532141 30.2953 0.00189702C27.4742 0.112119 27.2499 6.6546 27.5785 11.0792C26.6487 14.9921 23.5311 19.8734 23.9397 10.0872C23.9798 9.40228 24.02 9.14247 23.6753 8.88268C23.4109 8.68585 22.8178 8.78031 22.4971 8.7882C22.1044 8.80395 22.0003 9.03226 21.9201 9.3708C21.7198 10.2526 21.6797 11.1107 21.6476 12.2838C21.6317 12.8349 21.5835 13.0869 21.3671 13.8348C21.1507 14.5827 19.9325 15.9448 19.2593 15.7165C18.3295 15.4015 18.6341 12.8271 18.8103 11.0556C18.9547 9.65423 18.4898 9.03226 17.3037 8.80395C16.6064 8.66223 16.1816 8.68585 15.4603 8.45752C14.771 8.24496 14.6188 6.96953 13.1601 7.39467C12.3586 7.63087 12.8716 9.29207 12.6792 10.5281C11.7335 16.5982 9.76988 16.7636 8.8562 13.8191C12.9597 3.93054 10.0344 0.0333891 8.32723 0.0333891C6.54799 0.0333891 4.51226 1.23796 5.36982 8.95353C4.95306 8.83543 4.82483 8.77245 4.35997 8.77245C1.77124 8.76458 0 10.8273 0 13.3703C0 15.9133 1.77124 17.976 4.368 17.976C5.89879 17.976 6.97275 17.2911 7.79025 16.2361C8.31922 16.984 8.96842 17.9918 10.1546 17.9445C13.681 17.8107 14.7069 10.7013 14.8271 10.2998C15.2038 10.3549 15.5645 10.4651 15.9091 10.5203C16.4862 10.6069 16.5343 10.8352 16.5182 11.402C16.366 16.2361 17.2716 17.9288 19.3315 17.9288C20.4774 17.9288 21.5034 16.8187 22.2087 16.0314C22.7377 17.1021 23.571 17.8973 24.7013 17.9288C27.4262 17.9918 28.4762 13.7246 28.38 14.2836C28.3078 14.7245 29.2615 17.8973 32.0748 17.913C35.553 17.9288 36.2022 14.1733 36.2744 13.5435C36.2904 13.4333 36.2825 13.4175 36.2744 13.5435C36.2744 13.5514 36.2744 13.5671 36.2744 13.5829C37.3804 13.3782 37.9494 12.8034 37.9494 12.8034C37.9494 12.8034 38.839 17.976 42.1171 17.9209C45.5234 17.8579 46.1724 14.4646 46.2527 13.8033C46.2686 13.6616 46.2607 13.6459 46.2527 13.8033C46.2527 13.8112 46.2527 13.8191 46.2527 13.8191C47.567 13.3467 47.9117 12.8822 47.9117 12.8822C47.9117 12.8822 48.617 17.9524 52.0793 17.9996C55.165 18.0391 56.311 14.9292 56.319 13.6301C56.84 13.638 57.8018 13.3231 57.7778 13.3073C57.7778 13.3073 58.9078 17.7398 62.0656 17.9681C63.5483 18.0783 64.6622 17.1493 65.2955 16.7242C66.7862 17.913 71.7473 19.4247 74.8811 14.2048C75.3298 13.4648 74.3761 12.5751 74.2079 12.4649ZM4.23975 16.2518C2.72499 16.2518 1.75521 14.8741 1.75521 13.3939C1.75521 11.9138 2.64484 10.536 4.15962 10.536C4.84086 10.536 5.21755 10.6069 5.75453 11.0635C5.85071 11.4335 6.1232 12.2917 6.25946 12.6853C6.43577 13.205 6.65217 13.6537 6.86055 14.134C6.54799 15.3779 5.55416 16.2518 4.23975 16.2518ZM7.92651 11.1029C7.86239 11.0005 7.87842 11.0635 7.80628 10.969C7.53379 10.229 6.99681 8.57562 6.93269 6.69397C6.86055 4.56826 7.22122 2.0725 8.28716 2.0725C9.00849 2.0725 9.77789 7.12699 7.92651 11.1029ZM29.2534 8.89054C29.0852 7.63087 29.0772 2.00165 30.4478 2.1591C31.2092 2.45828 29.9668 7.7647 29.2534 8.89054ZM39.2958 8.89054C39.1276 7.63087 39.1196 2.00165 40.4902 2.1591C41.2515 2.45828 40.0092 7.7647 39.2958 8.89054ZM49.2581 8.96928C49.0897 7.70958 49.0819 2.08037 50.4523 2.23783C51.2136 2.52914 49.9715 7.84343 49.2581 8.96928ZM60.2543 1.82057C61.5126 1.6946 61.4565 7.08763 58.9399 10.4888C58.6112 9.26057 58.1144 2.24572 60.2543 1.82057ZM65.544 13.4333C65.1432 11.4257 66.1851 10.1109 67.2591 9.96914C67.6358 9.91404 68.1808 10.1502 68.2849 10.599C68.4613 11.4414 68.2609 12.6932 65.8485 14.2757C65.8566 14.2836 65.6321 13.8742 65.544 13.4333ZM22.914 7.24507C23.7715 7.24507 24.4687 6.56012 24.4687 5.71772C24.4687 4.8753 23.7715 4.19035 22.914 4.19035C22.0564 4.19035 21.359 4.8753 21.359 5.71772C21.359 6.56012 22.0564 7.24507 22.914 7.24507Z" fill="white"/>
                    </svg>
                </div>
              </div>
            </div>
            
            <div className="card__inner user-date">
              <h4>Dribbbler since {clean_up_date(user.created_at)}</h4>
            </div>
            
            <div className="card__inner stats">
              <div className="card__stats">
                <h2>{numberWithCommas(likes_count)}</h2>
                <p>Likes</p>
              </div>
              <div className="card__stats">
                <h2>{numberWithCommas(view_count)}</h2>
                <p>Views</p>
              </div>
              <div className="card__stats">
                <h2>{numberWithCommas(shot_count)}</h2>
                <p>Shots</p>
              </div>
            </div>
          </div>
      </div>
          
    </div>
  )
}
export default Generated;